import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addCommentAction } from "../data/redux/actions/TaskActions";

interface Comment {
  id: number;
  text: string;
  timestamp: string;
}

interface TaskCommentsModalProps {
  taskId: any;
}

const TaskCommentsModal: React.FC<TaskCommentsModalProps> = ({ taskId}) => {
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState<any>('');
  const dispatch = useDispatch<any>();
  const handleAddComment = () => {
    if (!commentText.trim()) return;

    setComments(commentText);
    setCommentText("");
    dispatch(addCommentAction({ taskId: taskId, remarks: commentText }))
  };

  return (
    <>
      {/* Bootstrap Modal */}
      <div className="modal fade" id="add_comment" tabIndex={-1} aria-labelledby="taskCommentsModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="taskCommentsModalLabel">Add Comment</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="commentText" className="form-label">Comment</label>
                <textarea
                  className="form-control"
                  id="commentText"
                  rows={3}
                  placeholder="Write your comment here..."
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                ></textarea>
              </div>

            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary ms-2" onClick={handleAddComment}>Submit Comment</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskCommentsModal;
